import Container from 'components/molecules/Container/Container';
import { appSwitchRoutes } from 'constants/routes';
import NavbarWithBackLink from 'components/molecules/NavbarWithBackLink/NavbarWithBackLink';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Loader } from '@spotted-zebra-uk/ui-components';
import DeiFormView from 'views/StageActionDeiForm/DeiFormView';
import { useRoleStageActionsFlow } from './useRoleStageActionsFlow';

const RoleStageDeiForm: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    roleId,
    stageId,
    role,
    stage,
    loading,
    exiting,
    actionsUrl,
    thankYouUrl,
  } = useRoleStageActionsFlow();

  if (loading) {
    return (
      <Container className="page-loader-wrapper">
        <Loader variant="bubbles" />
      </Container>
    );
  }

  if (exiting || !role || !stage) {
    return null;
  }

  return (
    <DeiFormView
      stageCandidateId={stage.stageCandidateId}
      exitUrl={actionsUrl}
      introUrl={appSwitchRoutes.roleStageDeiIntro.getUrl(roleId, stageId)}
      onSubmitted={() => navigate(thankYouUrl)}
      navbar={
        <NavbarWithBackLink
          to={actionsUrl}
          ariaLabel={t('assessment.returnToAllAssessmentActions')}
          label={t('assessment.actions')}
        />
      }
    />
  );
};

export default RoleStageDeiForm;
